import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {ACTION_TYPES} from "../consts";
import {AllScoresLinkClickEvent} from "../models/events/all-scores-link.click-event";

export class AllScoresLinkClickEventHandler extends AnalyticsEventHandler {
  analyticsService: AnalyticsService;
  type = ACTION_TYPES.allScoresLinkClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = AllScoresLinkClickEvent;
  }

  async action(params) {
    super.action(params);

    this.navigationManager.gotoUrl(params.url, false, true);
  }
}
